module.exports = __webpack_public_path__ + "img/icon-not-attend.a158ce7b.svg";